export default __webpack_public_path__ + "static/media/mango_slushie_thumbnail.b34dc1ee.JPG";